import { FormItem } from 'azure-devops-ui/FormItem';
import { TextField, TextFieldStyle, TextFieldWidth } from 'azure-devops-ui/TextField';
import React from 'react';
import { ObservableValue } from 'azure-devops-ui/Core/Observable';
import { Panel } from 'azure-devops-ui/Panel';
import { Persona } from '../../../clients/ogg';

export interface IPersonaEditorProps {
  persona: Persona;
  onPersonaChanged: (persona: Persona) => void;
  onCancel: () => void;
  onDelete: () => void;
}

export default function PersonaEditor(props: IPersonaEditorProps) {
  const name = new ObservableValue<string>(props.persona.name);
  const description = new ObservableValue<string>(props.persona.description);

  return (
    <Panel
      onDismiss={() => props.onCancel()}
      titleProps={{ text: `Set up ${props.persona.name ?? 'new'} Persona` }}
      description={`Describe your persona in 1-2 sentences. For example: 
          "Focuses on overview and management capabilities. Interested in dashboards, reporting tools, and overview functions to monitor progress and make informed decisions"`}
      footerButtonProps={[
        { text: 'Cancel', onClick: () => props.onCancel() },
        { text: 'Delete', danger: true, onClick: () => props.onDelete() },
        {
          text: 'Save',
          primary: true,
          onClick: () => props.onPersonaChanged(props.persona),
        },
      ]}
    >
      <div className='flex-column rhythm-vertical-16 full-width' style={{ flexWrap: 'wrap' }}>
        <FormItem label='Title' message='The title of the persona'>
          <TextField
            value={name}
            onChange={(event, value) => {
              name.value = value;
              props.persona.name = value;
            }}
            width={TextFieldWidth.auto}
            required
            style={TextFieldStyle.inline}
          />
        </FormItem>
        <FormItem label='Description' message='The description of the persona in 1-2 sentences'>
          <TextField
            value={description}
            onChange={(event, value) => {
              description.value = value;
              props.persona.description = value;
            }}
            multiline
            rows={7}
            width={TextFieldWidth.auto}
            style={TextFieldStyle.inline}
          />
        </FormItem>
      </div>
    </Panel>
  );
}
